module.exports = __webpack_public_path__ + "fonts/rig.f7fa1772.ttf";